import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import FormOrder from '../../types/api/form-order'
import getQuery from '../../helpers/api/get-query'

export const formOrdersApi = createApi({
    reducerPath: 'formOrdersApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['FormOrders'],
    endpoints: builder => ({
        getFormOrders: builder.query<Strapi<FormOrder>, EndpointQueryParameters | void>({
            query: getQuery('/form-orders'),
            providesTags: ['FormOrders'],
        }),
        getFormOrderByDocId: builder.query<
            StrapiSingle<FormOrder>,
            [string, EndpointQueryParameters | void]
        >({
            query: ([docId, params]) => getQuery(`/form-orders/${docId}`)(params),
            providesTags: ['FormOrders'],
        }),
        createFormOrder: builder.mutation<StrapiSingle<FormOrder>, StrapiCreate<FormOrder>>({
            query: body => ({
                url: '/form-orders',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['FormOrders'],
        }),
        updateFormOrder: builder.mutation<StrapiSingle<FormOrder>, StrapiUpdate<FormOrder>>({
            query: ({ docId, body, queryParams }) => ({
                url: getQuery(`/form-orders/${docId}`)(queryParams),
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['FormOrders'],
        }),
    }),
})

export const {
    useGetFormOrdersQuery,
    useGetFormOrderByDocIdQuery,
    useCreateFormOrderMutation,
    useUpdateFormOrderMutation,
} = formOrdersApi